export const INTERNALANNOUNCEMENT_SHOW_RESET = 'INTERNALANNOUNCEMENT_SHOW_RESET'
export const INTERNALANNOUNCEMENT_SHOW_SET_ERROR = 'INTERNALANNOUNCEMENT_SHOW_SET_ERROR'
export const INTERNALANNOUNCEMENT_SHOW_SET_RETRIEVED = 'INTERNALANNOUNCEMENT_SHOW_SET_RETRIEVED'
export const INTERNALANNOUNCEMENT_SHOW_TOGGLE_LOADING = 'INTERNALANNOUNCEMENT_SHOW_TOGGLE_LOADING'
